<template>
  <div class="c-left-synctree-tags">
    <FontAwesomeIcon
      v-if="sourceField.isReferenceField"
      :icon="['fak', 'link']"
      :style="{ height: '12px', width: '12px' }"
      class="text-primary-accent p-4 bg-primary-background-weak rounded-full"
    />
    <FontAwesomeIcon
      v-if="sourceField.blockedPops.length > 0"
      :icon="['fak', 'population']"
      :style="{ height: '12px', width: '12px' }"
      class="text-primary-accent p-4 bg-primary-background-weak rounded-full"
    />
    <FontAwesomeIcon
      v-if="sourceField.isPotInfAmountField"
      :icon="['fak', 'revenue']"
      :style="{ height: '12px', width: '12px' }"
      class="text-primary-accent p-4 bg-primary-background-weak rounded-full"
    />
  </div>
</template>
<script setup>
defineProps({
  sourceField: {
    type: Object,
    required: true,
  },
});
</script>
